import React from 'react';
import { Input, Select, Radio, Button } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

const { Option } = Select;

const selectedStyle = {
  borderColor: '#FA8C16',
  boxShadow: 'none',
  background: '#fff',
  color: '#FA8C16',
  fontWeight: 400,
};

const selectedPurpleStyle = {
  borderColor: '#9254DE',
  boxShadow: 'none',
  background: '#fff',
  color: '#9254DE',
  fontWeight: 400,
};

const unselectedStyle = {
  borderColor: '#D9D9D9',
  boxShadow: 'none',
  background: '#fff',
  color: 'rgba(0, 0, 0, 0.88)',
};

const ConditionRow = ({ row, onDelete }) => {
  const dotColor = row.type === 'And' ? '#9254DE' : '#FA8C16';

  return (
    <div className='condition-row d-flex alignCenter gap-8'>
      <span className='condition-dot' style={{ background: dotColor }} />
      <Select value={row.field || 'online_is_anniversary'} className='Input-border InputSelect condition-select w-85'>
        <Option value='online_is_anniversary'>online_is_anniversary</Option>
        <Option value='online_status'>online_status</Option>
      </Select>
      <Select value={row.operator || '='} className='Input-border InputSelect condition-operator w-64'>
        <Option value='='>=</Option>
        <Option value='>='>&gt;=</Option>
        <Option value='<='>&lt;=</Option>
        <Option value='>'>&gt;</Option>
        <Option value='<'>&lt;</Option>
        <Option value='!='>!=</Option>
      </Select>
      <Input value={row.value || ''} placeholder='Input' className='Input-border InputText condition-input w-120' />
      <div className='condition-delete-box'>
        <button type='button' className='condition-delete-btn delete-btn' onClick={onDelete}>
          <DeleteOutlined style={{ color: '#FF4D4F' }} />
        </button>
      </div>
    </div>
  );
};

const EligibilityConditionGroup = ({
  group,
  onChangeType,
  onAddCondition,
  onAddNestedGroup,
  onRemoveGroup,
  onRemoveCondition,
  children,
}) => {
  const groupText = group.type === 'And'
    ? '(All of the following must be true)'
    : '(Any one of the following must be true)';

  return (
    <div className='condition-border-box condition-box mt-16 nested-condition-group'>
      <div className='attribute-condition-card'>
        <div className='condition-wrapper'>
          <div className='condition-connector'>
            <div className='condition-connector-header'>
              <div className='RadioGroup d-flex justifyContentSpaceBetween alignCenter'>
                <Radio.Group
                  value={group.type}
                  onChange={(e) => onChangeType(group.id, e.target.value)}
                  className='RadioGroup-inline'
                >
                  <Radio.Button
                    value='And'
                    style={group.type === 'And'
                      ? { ...selectedPurpleStyle, '--radio-checked-color': '#9254DE' }
                      : { ...unselectedStyle, '--radio-checked-color': '#D9D9D9' }}
                  >
                    And
                  </Radio.Button>
                  <Radio.Button
                    value='Or'
                    style={group.type === 'Or'
                      ? { ...selectedStyle, '--radio-checked-color': '#FA8C16' }
                      : { ...unselectedStyle, '--radio-checked-color': '#D9D9D9' }}
                  >
                    Or
                  </Radio.Button>
                </Radio.Group>

                <button type='button' className='condition-delete-btn delete-btn' onClick={() => onRemoveGroup(group.id)}>
                  <DeleteOutlined style={{ color: '#FF4D4F' }} />
                  <span style={{ marginLeft: 8, color: '#FF4D4F' }}>Remove group</span>
                </button>
              </div>
              <span className='RadioGroup-text'>{groupText}</span>
            </div>
          </div>

          {group.conditions.map((row) => (
            <ConditionRow
              key={row.id}
              row={{ ...row, type: group.type }}
              onDelete={() => onRemoveCondition(group.id, row.id)}
            />
          ))}
        </div>

        {children && <div className='nested-group-list'>{children}</div>}

        {(group.afterConditions || []).map((row) => (
          <ConditionRow
            key={row.id}
            row={{ ...row, type: group.type }}
            onDelete={() => onRemoveCondition(group.id, row.id)}
          />
        ))}

        <div className='condition-footer mt-16'>
          <div className='footer-btn-box d-flex gap-8'>
            <Button type='default' icon={<PlusOutlined />} onClick={() => onAddCondition(group.id)}>
              Add Condition
            </Button>
            <Button type='default' icon={<PlusOutlined />} onClick={() => onAddNestedGroup(group.id)}>
              Add Nested Group
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EligibilityConditionGroup;
